import Vue from 'vue'
import axios from 'axios'
import numbro from 'numbro'

export default {

  computed: {
    SelectedColumns: function () {
      var count = 0
      for (var i = 0; i < this.column_models.length; i++) {
        if (this.column_models[i].visible) { count++ }
      }
      return count
    }
  },

  methods: {
    /*
     * Handle page-change event
     */
    onPageChange (page) {
      this.page = page
      this.loadAsyncData()
    },
    /*
     * Handle sort event
     */
    onSort (field, order) {
      this.sortField = field
      this.sortOrder = order
      this.loadAsyncData()
    },
    ColumnVisible: function (field) {
      var visible = false
      for (var i = 0; i < this.column_models.length; i++) {
        var cm = this.column_models[i]
        if (cm.name == field) {
          visible = cm.visible
          break
        }
      }
      return visible
    },
    ColumnLabel: function (field) {
      var label = ''
      for (var i = 0; i < this.column_models.length; i++) {
        var cm = this.column_models[i]
        if (cm.name == field) {
          label = cm.label
          break
        }
      }
      return label
    },
    ws_formatter: function (ws) {
      var wsclass = ''
      if (ws < 10) { wsclass = 'whalescore-one' } else if (ws < 20) { wsclass = 'whalescore-two' } else if (ws < 30) { wsclass = 'whalescore-three' } else if (ws < 40) { wsclass = 'whalescore-four' } else if (ws < 50) { wsclass = 'whalescore-five' } else if (ws < 60) { wsclass = 'whalescore-six' } else if (ws < 70) { wsclass = 'whalescore-seven' } else if (ws < 80) { wsclass = 'whalescore-eight' } else if (ws < 90) { wsclass = 'whalescore-nine' } else { wsclass = 'whalescore-ten' }

      var cell = {}
      cell[wsclass] = true
      cell['white--text'] = true
      return cell
    },
    ColumnUpdate: function (e) {
      for (var i = 0; i < this.column_models.length; i++) {
        var cm = this.column_models[i]
        var idx = this.visible_columns.indexOf(cm.name)
        cm.visible = (idx >= 0)
      }
    },
    /*
     * Load async data
     */
    loadAsyncData () {
      this.loading = true
      var that = this
      var url = this.build_search_url()
      var params = this.build_search_criteria()
      axios.get(url, {
        params: params

      })
        .then(function (response) {
          var data = response.data
          that.data = []
          that.results = response.data
          that.total = data.records

          data.rows.forEach((item) => that.data.push(item))
          that.loading = false
          that.update_facet_counts()
        })
        .catch(function (error) {
          console.log(error)
          that.loading = false
        })
    },
    setup_search_facets: function () {
      for (var i = 0; i < this.SearchFacets.length; i++) {
        var sf = this.SearchFacets[i]
        sf.expanded = false

        sf.selected_count = 0
        sf.custom_data = []
        for (var j = 0; j < sf.data.length; j++) {
          var d = sf.data[j]
          d.full_description = sf.title + ': ' + d.description
          d.filter_identifier = sf.identifier
        }
      }
    },
    update_facet_counts: function () {
      var facets = this.results.facets
      for (var i = 0; i < this.SearchFacets.length; i++) {
        var sf = this.SearchFacets[i]
        var facet_counts = facets[sf.identifier]
        for (var j = 0; j < sf.data.length; j++) {
          var d = sf.data[j]
          d.count = this.find_count(d.id, facet_counts)
        }
      }
    },
    find_count: function (id, facet) {
      var count = 0
      if (facet) {
        for (var i = 0; i < facet.length; i++) {
          var f = facet[i]
          if (f.value == id) {
            count = f.count
            break
          }
        }
      }
      return count
    },
    build_search_criteria: function () {
      var c = {
        rows: this.rows,
        page: this.page,
        sidx: this.sortField,
        sord: this.sortOrder
      }
      if (this.criteria && this.criteria.or_filers) {
        c['or_filers'] = this.criteria.or_filers
      }
      if (this.group && this.group.filers.length > 0) {
        var ids = ''
        for (var i = 0; i < this.group.filers.length; i++) {
          if (ids.length > 0) { ids += ',' }
          ids += this.group.filers[i].id
        }
        c['filer_ids'] = ids
      }
      for (var i = 0; i < this.selected_facets.selected_options.length; i++) {
        var option = this.selected_facets.selected_options[i]
        if (option.custom) {
          var fieldname = option.filter_identifier
          if (!c[fieldname]) { c[fieldname] = [] }
          c[fieldname].push('' + option.from + '|' + option.to)
        } else if (option.sector) {
          var fieldname = option.filter_identifier
          if (!c[fieldname]) { c[fieldname] = [] }
          c[fieldname].push(option.id + '|' + option.from + '|' + option.to)
        } else {
          if (!c[option.filter_identifier]) { c[option.filter_identifier] = [] }
          c[option.filter_identifier].push('' + option.id)
        }
      }
      if (this.selected_facets.keywords && this.selected_facets.keywords.length > 0) {
        c['txt_filer_name'] = this.selected_facets.keywords
        if (this.selected_facets.text_to_search) { c['text_to_search'] = this.selected_facets.text_to_search }
      }
      if (this.selected_facets.proximity_miles && this.selected_facets.proximity_postal_code) {
        c['proximity_miles'] = this.selected_facets.proximity_miles
        c['proximity_postal_code'] = this.selected_facets.proximity_postal_code
      }

      return c
    }
  }
}
